<template>
  <v-app
    :dark="darkMode"
    id="inspire"
    :class="[{ 
            'box-layout': boxLayout, 
            'collapse-sidebar': collapseSidebar, 
            'rtl-layout': rtlLayout
        }]">
    <transition name="loginFade" mode="out-in">
      <router-view v-if="!checkBlockedBrowsers()"/>
      <browser-blocked v-if="checkBlockedBrowsers()"></browser-blocked>
    </transition>
    
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { locale } from 'devextreme/localization'

// Devextreme styles
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.material.blue.light.css'

import BrowserBlocked from '@/views/errors/BrowserBlocked.vue'

export default {
  components: {
    BrowserBlocked
  },
  data() {
    // authNotifier.on('authChange', authState => {
    //   this.authenticated = authState.authenticated;
    // });
    return {
      // auth,
      // authenticated,
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      'darkMode',
      'collapseSidebar',
      'boxLayout',
      'rtlLayout',
      'selectedLocale'
    ])
  },
  methods: {
    checkBlockedBrowsers () {
      const userAgent = navigator.userAgent
        var msie = userAgent.indexOf('MSIE ')
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10)
        }
        var trident = userAgent.indexOf('Trident/')
        if (trident > 0) {
          // IE 11 => return version number
          var rv = userAgentua.indexOf('rv:')
          return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10)
        }
      return false
    }
  },
  mounted () {
      locale('de')
  }
}
</script>
<style>
    .vue-grid-item.vue-grid-placeholder {
        background-color: rgb(53, 53, 53);
    }
</style>